import { InMemoryCache } from '@apollo/client';

const cache = new InMemoryCache();

// cache.writeData({
//   data: {
//     isAuthorized: false,
//   },
// });

export default cache;
